// Tilespread format for 2-color edge-matched Wang tiles
// Good for single-tile-width paths and rivers that include all corner details
// in a single tile.
//
// There are four edges that this tile needs to match. Each neighbor either matches
// or it doesn't, two values. Therefore we need 2^4 tile images to construct a full
// path. We index these 2^4 = 16 possible values using a binary string. The first bit
// is true if there is a matching neighbor to the north. Going clockwise: the second
// bit is for the east, the third bit for the south, and the fourth bit for the west.
export const wangEdgeMatch = {
    "4":  {"x": 0, "y": 0},
    "6":  {"x": 1, "y": 0},
    "14": {"x": 2, "y": 0},
    "12": {"x": 3, "y": 0},
    "5":  {"x": 0, "y": 1},
    "7":  {"x": 1, "y": 1},
    "15": {"x": 2, "y": 1},
    "13": {"x": 3, "y": 1},
    "1":  {"x": 0, "y": 2},
    "3":  {"x": 1, "y": 2},
    "11": {"x": 2, "y": 2},
    "9":  {"x": 3, "y": 2},
    "0":  {"x": 0, "y": 3},
    "2":  {"x": 1, "y": 3},
    "10": {"x": 2, "y": 3},
    "8":  {"x": 3, "y": 3},
}

// Tilespread format for 2-color corner-matched Wang tiles
// Good for continuous blocks that need to occupy full tiles
//
// There are four corners that this tile needs to match. (Assuming an offset grid)
// each corner either matches or it doesn't, two values. Therefore we need 2^4
// tile images to construct a full path. We index these 2^4 = 16 possible values
// using a binary string. The first bit is true if there is a matching corner
// to the northwest. Going clockwise, the second bit is for the northeast, the
// third bit for the southeast, and the fourth bit for the southwest.
export const wangCornerMatch = {
    "15":  {"x": 0, "y": 0},
    "3":  {"x": 1, "y": 0},
    "9": {"x": 2, "y": 0},
    "6": {"x": 3, "y": 0},
    "0":  {"x": 0, "y": 1},
    "12":  {"x": 1, "y": 1},
    "5": {"x": 2, "y": 1},
    "10": {"x": 3, "y": 1},
    "11":  {"x": 0, "y": 2},
    "7":  {"x": 1, "y": 2},
    "4": {"x": 2, "y": 2},
    "8":  {"x": 3, "y": 2},
    "13":  {"x": 0, "y": 3},
    "14":  {"x": 1, "y": 3},
    "2": {"x": 2, "y": 3},
    "1":  {"x": 3, "y": 3},
}

// Same tilespread format for 2-color corner-matched Wang tiles as above
// Good for continuous blocks that need to occupy full tiles
//
// This image layout arranges the corners to make a continuous shape for easier
// understanding while drawing them.
export const wangCornerContinuous = {
    "8":  {"x": 0, "y": 0},
    "6":  {"x": 1, "y": 0},
    "13": {"x": 2, "y": 0},
    "12": {"x": 3, "y": 0},
    "5":  {"x": 0, "y": 1},
    "14":  {"x": 1, "y": 1},
    "15": {"x": 2, "y": 1},
    "11": {"x": 3, "y": 1},
    "2":  {"x": 0, "y": 2},
    "3":  {"x": 1, "y": 2},
    "7": {"x": 2, "y": 2},
    "9":  {"x": 3, "y": 2},
    "0":  {"x": 0, "y": 3},
    "4":  {"x": 1, "y": 3},
    "10": {"x": 2, "y": 3},
    "1":  {"x": 3, "y": 3},
}
